import suchardJingleSrc from "./assets/audio/mc-suchard-60s-master-v1-14lufs.mp3";

const exampleExternalUrls = Object.freeze({
  crm: "https://www.suchard.es/",
});

const sharedModules = Object.freeze([
  "participation",
  "faq",
  "stories",
  "discover",
  "sustainability",
  "newsletter",
]);

export const campaignConfig = Object.freeze({
  activePhase: 1,
  phaseModules: Object.freeze({
    1: Object.freeze([
      "hero-default",
      "prizes",
      "villancicos",
      ...sharedModules,
    ]),
    2: Object.freeze([
      "hero-video",
      "prizes",
      "villancicos",
      ...sharedModules,
    ]),
    3: Object.freeze([
      "hero-video",
      "winners",
      "villancicos",
      "faq",
      "stories",
      "discover",
      "sustainability",
      "newsletter",
    ]),
  }),
  crmUrl: exampleExternalUrls.crm,
  youtube: Object.freeze({
    header: null,
    slider: Object.freeze({
      title: "Escucha nuestro coro",
      videos: Object.freeze([
        Object.freeze({
          //https://www.youtube.com/shorts/ivUvRCv-jNI
          youtubeId: "ivUvRCv-jNI",
          title: "Ejemplo 1 · Suchard 2025 · Son todas Navidades",
          posterUrl: "https://i.ytimg.com/vi/QYUZ4cUzEZw/maxresdefault.jpg",
        })
      ]),
      placeholderSlides: 3, 
    }),
    stories: Object.freeze({
      title: null,
      videos: Object.freeze([]),
    }),
  }),
  jingle: Object.freeze({
    enabled: true,
    src: suchardJingleSrc,
    loop: true,
    phases: Object.freeze([1, 2, 3]),
  }),
  winners: null,
  popup: Object.freeze({
    enabled: false,
    trigger: "load",
    frequency: "always",
    delayMs: 1500,
    scrollThreshold: 0.2,
    storageKey: "suchard-newsletter-popup-2026",
  }),
  legalUrls: Object.freeze({
    contact: "https://contactus.mdlzapps.com/mondelezinternationales/contact/es-ES",
    legal: "bases-legales.html",
    //legal: "SUCHARD_26-BBLL.pdf",
    cookies: "politica-cookies.html",
    terms: "terminos.html",
    privacy: "https://privacy.mondelezinternational.com/eu/es-ES/privacy-notice/",
  }),
});
